import React, { ReactElement } from "react";
import CoachVideo from "./CoachVideo";

interface TaskVideoFactoryProps {
    taskKey: string | null;
    videoUrl: string;
    isPreview?: boolean;
    onClose?: () => void;
    onTaskComplete?: () => void;
}

const TaskVideoFactory = ({
    taskKey,
    videoUrl,
    isPreview = false,
    onClose,
    onTaskComplete
}:TaskVideoFactoryProps): ReactElement | null => {
    if (!taskKey || !videoUrl) {
        return null;
    }

    return (
        <CoachVideo
            videoUrl={videoUrl}
            taskKey={taskKey}
            isPreview={isPreview}
            onClose={onClose}
            onTaskComplete={onTaskComplete}
        />
    );
};

export default TaskVideoFactory;

